import { Fragment } from 'react';
import { ButtonComponent, InputComponent } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { postLoginUser } from '../../redux/slices/auth-slice';
import { useNavigate } from 'react-router';
import { loginSchema } from '../../helpers/schemas';
import { useFormik } from 'formik';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { loading } = useSelector((state) => state.loginUserReducer);

    const initialValues = {
        userId: '',
        password: '',
    };

    const { handleChange, handleBlur, handleSubmit, values, touched, errors } = useFormik({
        initialValues: initialValues,
        validationSchema: loginSchema,
        onSubmit: (e) => {
            dispatch(postLoginUser(e)).then((action) => {
                if (action?.payload?.status === 200) {
                    if (action?.payload?.is2FAEnabled) {
                        navigate("/otp");
                    } else if (action?.payload) {
                        navigate("/app");
                    }
                }
            });
        }
    });

    return (
        <Fragment>
            <div className='text-contain'>
                <h3>Welcome</h3>
                <p>Please use your credentials to Login</p>
            </div>
            <form onSubmit={handleSubmit}>
                <div>
                    <InputComponent
                        label='Username'
                        type='text'
                        name='userId'
                        placeholder='Enter username'
                        autoFocus
                        onBlur={handleBlur}
                        value={values.userId}
                        onChange={handleChange}
                        mui
                    />
                    {
                        touched.userId && errors.userId && (
                            <p className="form-error">{errors.userId}</p>
                        )
                    }
                </div>
                <div>
                    <InputComponent
                        label='Password'
                        type='password'
                        name='password'
                        placeholder='Enter password'
                        onBlur={handleBlur}
                        value={values.password}
                        onChange={handleChange}
                        mui
                    />
                    {
                        touched.password && errors.password && (
                            <p className="form-error">{errors.password}</p>
                        )
                    }
                </div>
                <ButtonComponent fullWidth label={loading ? 'Loading' : 'Login'} type='submit' upperCase disabled={loading} />
            </form>
        </Fragment>
    );
};

export default Login;